import { useId } from 'react';
import type { ReactElement } from 'react';

import { IconCircleTick } from '@xing-com/icons';
import { scale110 } from '@xing-com/tokens';
import { Hero } from '@xing-com/typography';

import * as Styled from './basic-card.styled';
import type { BasicCardProps } from './basic-card.types';
import {
  CardBenefitsList,
  CardContainer,
  CardHeaderSection,
} from './sub-components';

export type { BasicCardProps } from './basic-card.types';

export const BasicCard = ({
  title,
  status,
  benefitsTitle,
  benefits,
}: BasicCardProps): ReactElement => {
  const titleId = useId();

  return (
    <CardContainer
      aria-labelledby={titleId}
      as="article"
      data-product-card="basic"
      size="large"
      padding="regular"
    >
      <CardHeaderSection>
        <Hero as="h2" id={titleId} size="small" noMargin>
          {title}
        </Hero>
        <Styled.CardStatusSubHeader>
          <IconCircleTick height={scale110} width={scale110} />
          <Styled.Status as="span" size="small" lineHeight="dense" noMargin>
            {status}
          </Styled.Status>
        </Styled.CardStatusSubHeader>
      </CardHeaderSection>
      <CardBenefitsList benefits={benefits} benefitsTitle={benefitsTitle} />
    </CardContainer>
  );
};
